import { Flex } from '@wegroup/design-system';
import React from 'react';

const QuestionGroupSubViewWrapper: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  return (
    <Flex
      maxW="700px"
      mx="auto"
      alignItems="flex-start"
      justifyContent="center"
      flexGrow={1}
      px="4"
      py="8"
      w="100%"
    >
      {children}
    </Flex>
  );
};

export default QuestionGroupSubViewWrapper;
